import { render, staticRenderFns } from "./AddProductFileComponent.vue?vue&type=template&id=dfb2eaba&scoped=true"
import script from "./AddProductFileComponent.vue?vue&type=script&lang=js"
export * from "./AddProductFileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb2eaba",
  null
  
)

export default component.exports